import { render, staticRenderFns } from "./PDV.vue?vue&type=template&id=c3a1683e"
import script from "./PDV.vue?vue&type=script&lang=js"
export * from "./PDV.vue?vue&type=script&lang=js"
import style0 from "./PDV.vue?vue&type=style&index=0&id=c3a1683e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports